/*
  Mamorigatana — reveal au scroll (IntersectionObserver).
  Lenis est désactivé : Horizon gère le scroll desktop, Lenis cassait le mobile.
*/
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shouldRevealImmediately(el) {
    if (el.closest('#header-group')) return true;
    if (el.closest('.mrg-announcement-bar, .mrg-announcement-section')) return true;
    if (el.closest('.mrg-apropos-trust')) return true;

    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function observeReveal(elements) {
    if (!elements.length) return;

    if (prefersReducedMotion || typeof IntersectionObserver !== 'function') {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var scrollRoot = null;
    if (window.matchMedia('(min-width: 990px)').matches) {
      scrollRoot = document.querySelector('.page-wrapper');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: '120px 0px 40px 0px',
        root: scrollRoot,
      }
    );

    elements.forEach(function (el) {
      if (shouldRevealImmediately(el)) {
        el.classList.add('is-visible');
        return;
      }

      var group = el.closest('[data-reveal-group]');
      if (group) {
        var groupItems = group.querySelectorAll('[data-reveal]');
        var groupIndex = 0;
        for (var i = 0; i < groupItems.length; i++) {
          if (groupItems[i] === el) {
            groupIndex = i;
            break;
          }
        }
        el.style.setProperty('--reveal-index', Math.min(groupIndex, 3));
      } else {
        el.style.setProperty('--reveal-index', 0);
      }
      observer.observe(el);
    });
  }

  function initReveal() {
    observeReveal(document.querySelectorAll('[data-reveal]'));
  }

  window.mrgInitReveal = function (root) {
    var scope = root || document;
    observeReveal(scope.querySelectorAll('[data-reveal]:not(.is-visible)'));
  };

  document.addEventListener('DOMContentLoaded', initReveal);
})();
